import { useState } from "react";
import { css } from "@emotion/react";

export const ButtonTypes = {
  primary: "primary",
  primary2: "primary2",
  secondary: "secondary",
  pink: "pink",
  light: "light",
};

const ToggleButton = ({ isChecked, setIsChecked, type, onClick = () => {},disabled }) => {
  // const [isChecked, setIsChecked] = useState(false);

  const toggleCheckbox = (event) => {
    setIsChecked(!isChecked);
    onClick(!isChecked);
  };

  const typeBasedStyles = getCorrespondingStyleObject(type);

  return (
    <label style={styles.container} onClick={(e)=>e.stopPropagation()}>
      <input
        type="checkbox"
        style={styles.input}
        checked={isChecked}
        onClick={toggleCheckbox}
        disabled={disabled}
      />
      <span
        style={styles.slider}
        css={
          isChecked
            ? typeBasedStyles.activeSlider
            : typeBasedStyles.disableSlider
        }
      ></span>
      <span
        style={styles.sliderBefore}
        css={
          isChecked
            ? typeBasedStyles.activeSliderBefore
            : typeBasedStyles.disableSliderBefore
        }
      ></span>
    </label>
  );
};

const styles = {
  container: {
    display: "inline-block",
    position: "relative",
    width: "34px",
    height: "20px",
  },
  input: {
    display: "none",
  },
  slider: {
    position: "absolute",
    cursor: "pointer",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    transition: "0.4s",
    borderRadius: "10px",
  },
  sliderBefore: {
    position: "absolute",
    content: '""',
    height: "12px",
    width: "12px",
    bottom: "4px",
    transition: "0.4s",
    borderRadius: "50%",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  },
};

function getCorrespondingStyleObject(type) {
  let activeSlider, disableSlider, activeSliderBefore, disableSliderBefore;

  switch (type) {
    case ButtonTypes.primary: {
      activeSlider = css`
        background-color: #e2e2e2;
        border: 1px solid #262626;
      `;
      disableSlider = css`
        background-color: #e2e2e2;
        border: 1px solid #AFAFAF;
      `;
      activeSliderBefore = css`
        left: 18px;
        background-color: #262626;
      `;
      disableSliderBefore = css`
        left: 3px;
        background-color: #AFAFAF;
      `;
      break;
    }
    case ButtonTypes.primary2: {
      activeSlider = css`
        background-color: #fff;
        border: 1px solid #262626;
      `;
      disableSlider = css`
        background-color: #fff;
        border: 1px solid #AFAFAF;
      `;
      activeSliderBefore = css`
        left: 18px;
        background-color: #262626;
      `;
      disableSliderBefore = css`
        left: 3px;
        background-color: #AFAFAF;
      `;
      break;
    }
    case ButtonTypes.secondary: {
      activeSlider = css`
        background-color: rgba(95, 46, 229, 0.08);
        border: 1px solid #5f2ee5;
      `;
      disableSlider = css`
        background-color: rgba(95, 46, 229, 0.08);
        border: 1px solid #5f2ee5;
      `;
      activeSliderBefore = css`
        left: 18px;
        background-color: rgba(95, 46, 229, 0.7);
      `;
      disableSliderBefore = css`
        left: 3px;
        background-color: rgba(95, 46, 229, 0.4);
      `;
      break;
    }
    case ButtonTypes.pink: {
      activeSlider = css`
        background-color: #ffd3e6;
        border: 1px solid #ec3366;
      `;
      disableSlider = css`
        background-color: #ffd3e6;
        border: 1px solid #ec3366;
      `;
      activeSliderBefore = css`
        left: 18px;
        background-color: #ef3e67;
      `;
      disableSliderBefore = css`
        left: 3px;
        background-color: #e86d8d;
      `;
      break;
    }
    case ButtonTypes.light: {
      activeSlider = css`
        background-color: #ccc;
        border: 1px solid #fff;
      `;
      disableSlider = css`
        background-color: #ccc;
        border: 1px solid #fff;
      `;
      activeSliderBefore = css`
        left: 18px;
        background-color: #fff;
      `;
      disableSliderBefore = css`
        left: 3px;
        background-color: #fff;
      `;
      break;
    }
  }
  return {
    activeSlider,
    disableSlider,
    activeSliderBefore,
    disableSliderBefore,
  };
}
export default ToggleButton;
